import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import Service from './service';
import { useMount, useRequest } from 'ahooks';
import { autobind } from 'core-decorators';
import AntdMessage from '@src/components/antd/message';
import { useEffect } from 'react';

class CultureSwiperStore {
  constructor({ ...rest } = {}) {
    Object.assign(this, rest);
  }

  swiperStore = new BaseSwiperStore();

  /**
   * 列表
   * @type {[{img: {}, title: string},{img: {}, title: string},{img: {}, title: string}]}
   */
  @observable list = [];

  @autobind
  async init() {
    try {
      const res = await this.getListRequest.run();
      this.list = res.list.map(item => {
        return {
          title: item.title,
          img: item.img
        };
      });
    } catch (err) {
      if (err.code === -10402 || err.code === -14601) {
        return;
      } else {
        AntdMessage.error(err.message);
        console.log(err.message, 'AntdMessage.error.navibar');
      }
    }
  }

  onClickSwiperGoNext = () => {
    this.swiperStore.goNext();
  };

  onClickSwiperGoPrev = () => {
    this.swiperStore.goPrev();
  };

  use() {
    this.getListRequest = useRequest(async () => await Service.getList(), { manual: true, throwOnError: true });
    useMount(() => {
      this.init();
    });
    useEffect(
      () => {
        this.isLoading = this.getListRequest.loading;
      },
      [this.getListRequest.loading]
    );
  }
}

export default CultureSwiperStore;
